// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z2NG","colBig":"styles_colBig__1qqA4","colSmall":"styles_colSmall__3kom8","shopifyNameWrapper":"styles_shopifyNameWrapper__AQMjJ"};